import { MdArrowBack } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import { Button, Icon } from '@nbirl/nbi-common-ui-libs';

import { useLocationHistory } from '../context';

type BackButtonProps = {
  path: string;
  label: string;
};

export const BackButton = ({ path, label }: BackButtonProps) => {
  const history = useHistory();
  const locations = useLocationHistory();

  const handleClick = () => {
    const previousLocation = locations[locations.length - 2];

    if (previousLocation && previousLocation.pathname === path) {
      history.goBack();
    } else {
      history.push(path);
    }
  };

  return (
    <Button
      aria-label={label}
      variant="light-teal"
      size="sm"
      onClick={handleClick}
      onlyIcon
    >
      <Icon icon={<MdArrowBack />} />
    </Button>
  );
};
